import React , {useEffect , useRef,useState , useCallback,memo}  from 'react';
import {ResGet} from './resapi'
import {interpolate} from "flubber"
import * as d3 from "d3";
const Filter = memo(props=>{
  const morphsvgfilter = useRef("")
  const pathRef = useRef("")
  const [data,setData] = useState([])
  const [defaultpath,setdefault] = useState("M9.5,9.5h-9V5c0-2.5,2-4.5,4.5-4.5l0,0c2.5,0,4.5,2,4.5,4.5V9.5z")
  const [name,setName] = useState("all")
  useEffect(()=>{
    ResGet("getfilter").then(response=>{
      if(response.status===200){
        setData(response.data)
      }
    })
  },[])
  const morphAnime = useCallback((end)=>{
    setTimeout(()=>{
    try {
      var interpolator =new interpolate(pathRef.current.getAttribute("d"), end,{ maxSegmentLength: 0.4,force: true,single: false});
        d3.select(pathRef.current)
        .transition()
        .duration(750)
        .ease(d3.easeLinear)
        .attrTween("d", function(inter) {return interpolator})
    } catch (error) {
    }
    },300)
    return false
  },[])
  const handelFlter=(params,path)=>{
    if(params==="all"){
      function handleReg(skipLimit){
          ResGet(`getwork/all/${skipLimit}`).then(async(response)=>{
            if(response.status===200 && response.data.length>0){
              await props.onSetData(value=>[...value,...response.data])
              await handleReg(skipLimit+20)
            }
          })
      }
      ResGet("getwork/all/0").then(async(response)=>{
        if(response.status===200){
          await setdefault(path)
          await setName(params)
          await props.onSetData(response.data)
          await handleReg(20)
          await props.setcount(0)
          await props.close()
        }
      })
    }else{
      function handleReg(skipLimit){
        ResGet(`search/work/${params}/${skipLimit}`).then(async(response)=>{
          if(response.status===200 && response.data.length>0){
            await props.onSetData(value=>[...value,...response.data])
            await handleReg(skipLimit+20)
          }
        })
      }
      ResGet(`search/work/${params}/0`).then(async(response)=>{
        if(response.status===200){
          await setdefault(path)
          await setName(params)
          await props.onSetData(response.data)
          await handleReg(20)
          await props.setcount(0)
          await props.close()
        }
      })
    }
  }
  return (
      <div className="content filter-main">
        <div className="box">
          <div className="image">
            <svg ref={morphsvgfilter} className="morphsvgfilter" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
              viewBox="0 0 11 11">
                   <path ref={pathRef} className="clickable" d={defaultpath}/>
            </svg> 
          </div>
        </div>

        <div className="box">
            <ul>
              <li className={`clickable ${name==="all"?"active":""}`}><span className="hoverline " onClick={()=>handelFlter("all","M9.5,9.5h-9V5c0-2.5,2-4.5,4.5-4.5l0,0c2.5,0,4.5,2,4.5,4.5V9.5z")}>َAll</span></li>
                {data.map((data,key)=>
                <li key={key} className={`clickable ${name===data.name?"active":""}`}><span className="hoverline " onClick={()=>handelFlter(data.name,data.path)} onMouseEnter={()=>morphAnime(data.path)} onMouseLeave={()=>morphAnime(defaultpath)}>{data.name}</span></li>
                )}
            </ul>
        </div>
      </div>
    )
})

export default Filter;